import { FC, ReactElement } from 'react';
import {GUTTER} from "../../../constants";
import {Col, Row} from "antd";
import {CommonlyMissedDataTableCard} from "../components/ConversationStory/CommonlyMissedDataTableCard";
import {SectionPerformanceCard} from "../components/Generic/SectionPerformanceCard";
import {
    AttemptConversationPerformanceDataTableCard
} from "../components/ConversationStory/AttemptConversationPerformanceDataTableCard";
import {FeedbackRowProps} from "./types";

export const ConversationStoryRow: FC<FeedbackRowProps> = ({attemptId, activityId, style}): ReactElement => (
    <Row gutter={GUTTER} style={style}>
        <Col xs={24} xl={12}>
            <CommonlyMissedDataTableCard attemptId={attemptId} activityId={activityId}/>
        </Col>
        <Col xs={24} xl={12}>
            {attemptId ? <AttemptConversationPerformanceDataTableCard attemptId={attemptId}/> :
                <SectionPerformanceCard type='conversation' activityId={activityId}/>}
        </Col>
    </Row>
);
